module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--20.3f5164b7.png";